import i18n from '@/locale/i18n'
import concert from '@/page/concert/index'
import applyForm from '@/page/concert/applyForm'
import applySuccess from '@/page/concert/applySuccess'
import signConfirm from '@/page/concert/signConfirm'
import invalidPage from '@/page/concert/invalidPage'

export default [
  {
    path: '/concert/:applyOver',
    component: concert,
    meta: { title: i18n.t('concert.concert28') }
  },
  {
    path: '/applyForm',
    component: applyForm,
    meta: { title: i18n.t('concert.concert32') }
  },
  {
    path: '/applySuccess',
    component: applySuccess,
    meta: { title: i18n.t('concert.concert34') }
  },
  {
    path: '/signConfirm',
    component: signConfirm,
    meta: { title: i18n.t('concert.concert26') }
  },
  {
    path: '/invalidPage',
    component: invalidPage,
    meta: { title: '演唱会' }
  }
]


// WEBPACK FOOTER //
// ./src/router/concert/index.js